// components/BuscadorClienteFactura/useBusquedaClientes.js
import { useState, useCallback, useEffect } from 'react';
import { debounce } from 'lodash';
import { UrlApi } from '../../../../services/apirest';

const useBusquedaClientes = (filtrosSeleccionados) => {
  const [resultados, setResultados] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  // Función para buscar clientes con filtros
  const buscarClientesFiltrados = useCallback(async (searchTerm) => {
    if (!searchTerm || searchTerm.trim().length < 2 || filtrosSeleccionados.length === 0) {
      setResultados([]);
      return;
    }

    setCargando(true);
    setError(null);

    try {
      const sucursales = localStorage.getItem("suc_auth")?.split(",") || [];
      
      if (sucursales.length === 0) {
        throw new Error('No hay sucursales configuradas');
      }

      const params = new URLSearchParams({
        search: searchTerm.trim(),
        limit: 50,
        filtros: filtrosSeleccionados.join(',')
      });

      const response = await fetch(
        `${UrlApi}/envasado_clientes/buscarClientesSucAuth/${sucursales.join(',')}?${params}`
      );

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      setResultados(data);
    } catch (error) {
      console.error('Error buscando clientes:', error);
      setError(error.message);
      setResultados([]);
    } finally {
      setCargando(false);
    }
  }, [filtrosSeleccionados]);

  // Debounce para búsqueda
  const debouncedSearch = useCallback(
    debounce((searchTerm) => {
      buscarClientesFiltrados(searchTerm);
    }, 400),
    [buscarClientesFiltrados]
  );

  // Limpiar resultados
  const limpiarResultados = useCallback(() => {
    setResultados([]);
    setError(null);
  }, []);

  return {
    resultados,
    cargando,
    error,
    buscarClientesFiltrados,
    debouncedSearch,
    limpiarResultados
  };
};

export default useBusquedaClientes;